import React from 'react';
import curriculumContext from './CurriculumContext';

const useCurriculumContext = () => React.useContext(curriculumContext);

export default useCurriculumContext;
